export default __webpack_public_path__ + "static/media/hsg_black_logo.d8b37a56.png";